<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/consumables/consumables-list' }">耗材管理</el-breadcrumb-item>
          <el-breadcrumb-item >使用单位详情</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="detail-content">
      <!--1. 医院信息 -->
        <div class="equipment-message">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">使用单位信息</div>
            </div>
            <!-- <div class="header-common-right">
            </div> -->
          </div>
          <div class="content">
              <el-descriptions
              class="margin-top"
              :column="2" border
              :contentStyle="contentStyle"
              :labelStyle='labelStyle'
              >
              <el-descriptions-item label="所在地区" >
                <span >{{area.provinceName}}/{{area.cityName}}</span>
              </el-descriptions-item>
              <el-descriptions-item label="使用单位" >
                <span >{{hospitalName}}</span>
              </el-descriptions-item>
              <el-descriptions-item label="耗材告警阈值" >
                <span >{{stockThreshold}}</span>
                <button class="stock" v-if="showConsAlert==true" @click="handleStockThreshold">修改</button>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="耗材剩余" >
                <span >{{tableConsUnusedData.length}}</span>
                  <el-tooltip class="item" effect="dark" :content="stockThreshold" placement="top-start" >
                    <el-button style="margin-left: 50px;background-color: orange;color: #fff;border: 0px;" size="mini" @click="handleStockThreshold">告警阈值</el-button>
                  </el-tooltip>
              </el-descriptions-item>
              <el-descriptions-item label="耗材消耗" >
                <span >{{tableConsUsedData.length}}</span>
              </el-descriptions-item> -->
              </el-descriptions>
          </div>
        </div>
        <div class="equipment-message" style="margin-top: 20px;" v-if="showEquipList==true">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">设备列表</div>
            </div>
          </div>
          <div class="content">
            <el-table
              v-loading='loading1'
              border
              :data="tableEquipmentData"
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              >
              <el-table-column
                type="index"
                label="序号"
                >
              </el-table-column>
              <!-- <el-table-column
                prop="shipDate"
                label="出库日期">
              </el-table-column> -->
              <el-table-column
                prop="typeName"
                label="产品名称">
              </el-table-column>
              <el-table-column
                prop="typeModel"
                label="规格型号">
              </el-table-column>
              <el-table-column
                prop="udi"
                label="UDI"
                >
              </el-table-column>
              <el-table-column
                prop="status"
                label="当前状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==1">正常</span>
                  <span v-if="scope.row.status==2">关机</span>
                  <span v-if="scope.row.status==3">故障</span>
                  <span v-if="scope.row.status==4">手术中</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <router-link class="action-button-base" :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id}}">
                    使用记录
                  </router-link>
                  <router-link v-if="showEquipMaintain==true" class="action-button-base" :to="{path:'/manage/equipment/equipment-details',query:{id:scope.row.id}}">
                    维护记录
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

       <div class="equipment-record" v-if="showConsUsed==true || showConsInventory==true">
          <div class="condition">
            <div style="">
              <el-tabs
              type="border-card"
              style="background-color: transparent;border: 1px solid #1A3F81;border-radius: 12px 12px 0px 0px;"
              v-model="activeName"
              @tab-click="handleClick"
              >
                  <el-tab-pane style="background-color: transparent;" name="consUnused" v-if="showConsInventory==true">
                    <span slot="label"><i class="el-icon-date"></i> 耗材剩余记录</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">耗材剩余记录</div>
                          </div>
                          <div class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportTable(1)"
                              type="text"
                              >
                              导出
                            </el-button>
                          </div>
                        </div>
                        <div>
                          <el-table
                            v-loading='loading2'
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            style="width: 100%;"
                            :data="tableConsUnusedData.filter(data => !search1 || data.shipDate.toLowerCase().includes(search1.toLowerCase()) || data.type.toLowerCase().includes(search1.toLowerCase()) || data.udi.toLowerCase().includes(search1.toLowerCase()))"
                            >

                            <el-table-column
                              type="index"
                              label="序号"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="shipDate"
                              label="出库日期">
                            </el-table-column>
                            <el-table-column
                              prop="typeName"
                              label="产品名称"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="typeModel"
                              label="规格型号"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="udi"
                              label="UDI">
                            </el-table-column>
                            <el-table-column
                              label="状态"
                              >
                              未使用
                              <template slot="header" slot-scope="scope">
                                <el-input
                                  id="search1"
                                  v-model="search1"
                                  size="mini"
                                  placeholder="输入关键字搜索"/>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane style="background-color: transparent;" name="consUsed" v-if="showConsUsed==true">
                    <span slot="label"><i class="el-icon-date"></i> 耗材消耗记录</span>
                    <div class="list-used">
                        <div class="header-common">
                          <div class="header-common-left">
                            <div class="title">耗材消耗记录</div>
                          </div>
                          <div class="header-common-right">
                            <el-button
                              class="right-button-export"
                              @click="exportTable(2)"
                              type="text"
                              >
                              导出
                            </el-button>
                          </div>
                        </div>
                        <div >
                          <el-table
                            v-loading='loading2'
                            style="width: 100%;"
                            row-key="id"
                            border
                            default-expand-all
                            border
                            :cell-style="tableCellStyle"
                            :header-cell-style="tableHeaderCellStyle"
                            :max-height="tableHeight"
                            :data="tableConsUsedData.filter(data => !search2 || data.type.toLowerCase().includes(search2.toLowerCase()) || data.udi.toLowerCase().includes(search2.toLowerCase()) || data.useDate.toLowerCase().includes(search2.toLowerCase()))"
                            >

                            <el-table-column
                              type="index"
                              label="序号"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="shipDate"
                              label="出库日期"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="useDate"
                              label="使用日期"
                              >
                            </el-table-column>
                            <el-table-column
                              prop="typeName"
                              label="产品名称">
                            </el-table-column>
                              <el-table-column
                                prop="typeModel"
                                label="规格型号">
                              </el-table-column>
                              <el-table-column
                                prop="udi"
                                label="UDI">
                              </el-table-column>
                              <el-table-column
                                label="状态"
                                >已使用
                                <template slot="header" slot-scope="scope">
                                  <el-input
                                    id="search2"
                                    v-model="search2"
                                    size="mini"
                                    placeholder="输入关键字搜索"/>
                                </template>
                              </el-table-column>
                          </el-table>
                        </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
            </div>
            </div>
      </div>


    </div>
  </div>

</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSingleConversionUtil} from '../../../utils/povince_handle.js'
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return{
        contentStyle:{
          'border':'1px solid #1A3F81',
          'color' : '#fff',
          'font-size': '15px',
          'font-weight': 'solid',
          'border-bottom':'0px solid #1A3F81',
          'border-right':'0px solid #1A3F81'
        },
        labelStyle:{
          'width': '120px',
          'height': '20px',
          'font-size': '14px',
          'font-weight': 'bold',
          'color': '#00FFFF',
          'background-color':'transparent',
          'border':'1px solid #1A3F81',
          'border-bottom':'0px solid #1A3F81',
        },
        tableCellStyle() {
          return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;'
        },
        tableHeaderCellStyle() {
          return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;'
        },

        showActionAdd:false,
        showEquipMaintain:false,//维修记录
        showConsUsed:false,//使用记录
        showConsInventory:false,//库存记录
        showEquipList:false,
        showConsAlert:false,

        search1:'',
        search2:'',

        activeName:'consUnused',

        //医院信息
        area:{
          provinceCode:'',
          provinceName:'',
          cityCode:'',
          cityName:'',
        },
        id:'',
        hospitalName:'',
        stockThreshold:0,//阈值
        //设备列表
        tableEquipmentData:[],
        loading1:false,

        tableHeight:0,

        tableConsUnusedData:[],//耗材库存记录
        tableConsUsedData:[],//耗材使用记录
        loading2:false,
        loading3:false
      }
    },
    methods: {
      goBack(){
        this.$router.back()
      },
      handleClick(tab){
        this.search1 = ''
        this.search2 = ''
        if(tab.name=="consUnused"){
          this.getConsInventory()
        } else if(tab.name=="consUsed"){
          this.getConsUsed()
        }
      },
      toShowEquipmentMaintain(row){
        this.$router.push({
          path:'/manage/equipment/equipment-details',
          query:{
            id:row.id
          },
        });
      },
      //医院信息
      getHospitalMessage(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/brief';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              // 1.医院信息
              this.area.provinceCode = obj.data.provinceCode;
              this.area.cityCode = obj.data.cityCode;
              this.hospitalName = obj.data.name;
              this.stockThreshold = obj.data.stockThreshold;

              areaSingleConversionUtil.codeToName(this.area)

            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getEquipmentMessage(){
        this.loading1 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/equipment/detail';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading1 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.equipments){
                this.tableEquipmentData = obj.data.equipments;
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading1 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsUsed(){
        this.loading2 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/used';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading2 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              //4.耗材使用记录
              if(obj.data.consumables){
                this.tableConsUsedData = obj.data.consumables
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading2 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      getConsInventory(){
        this.loading3 = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/unused';
        const data = {"id":this.id} //医院ID

        this.$http({
          method:'GET',
          url:url,
          headers:headers,
          params:data
        }).then(res=>{
          this.loading3 = false
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              //3.医院耗材库存记录
              if(obj.data.consumables){
                this.tableConsUnusedData = obj.data.consumables;
              }
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading3 = false
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportTable(type){
        // 2-使用记录，1-剩余记录
        var tableHeader = [];
        var dataList = [];
        var documentName = ''
        switch(type){
          case 1:{
            tableHeader = [['序号','产品名称','规格型号','UDI','状态']];
            documentName = this.hospitalName+'-耗材剩余记录';
            this.tableConsUnusedData.forEach((item,index)=>{
              dataList.push([
                index+1,
                // item.shipDate,
                item.typeName,
                item.typeModel,
                item.udi,
                '未使用'
              ]);
            });
          }
          break;
          case 2:{
            tableHeader = [['序号','使用日期','产品名称','规格型号','UDI','状态']];
            documentName = this.hospitalName+'-耗材消耗记录';
            this.tableConsUsedData.forEach((item,index)=>{
              dataList.push([
                index+1,
                // item.shipDate,
                item.useDate,
                item.typeName,
                item.typeModel,
                item.udi,
                '已使用'
              ]);
            });
          }
          break;
          default: this.$message('导出错误')
          break;
        }

        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }


      },
      handleStockThreshold(){
        this.$prompt('请输入告警阈值', '修改耗材告警阈值', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.handleStockThresholdAction(value);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      // 设置阈值
      handleStockThresholdAction(value){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/update';
        const data = {"id":this.id,"threshold":value} //医院ID

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.stockThreshold = value;
              this.$message.success('修改成功');
            }else{
              this.$message.error(obj.message)
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      judgePermissions(){
          let per1 = permissionCheckUtil.findName("equipment:maintain");
          let per2 = permissionCheckUtil.findName("consumable:readUsed");
          let per3 = permissionCheckUtil.findName("consumable:readInventory");
          let per4 = permissionCheckUtil.findName("equipment:read");
          let per5 = permissionCheckUtil.findName("consumable:alert");


          if(per1==true){
            this.showEquipMaintain = true;
          }

          if(per2==true){
            this.showConsUsed = true;
          }

          if(per3==true){
            this.showConsInventory = true;
          }

          if(per4==true){
            this.showEquipList = true;
          }

          if(per5==true){
            this.showConsAlert = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-700 < 300 ? 300 : window.innerHeight-700;
        })
      },
    },
    created() {
      this.judgePermissions()

      this.id = this.$route.query.id;


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun);

      this.getHospitalMessage()
      if(this.showEquipList==true){
        this.getEquipmentMessage()
      }

      if(this.showConsInventory==true){
        this.getConsInventory()
      }else{
        if(this.showConsUsed==true){
          this.getConsUsed()
        }
      }

      this.sizeFun()
    }
  }
</script>


<style lang="scss" scoped>
.container{
  height: 100%;
  margin-top: $header-height;

  .bread >>>.el-breadcrumb__inner{
    color: #606266;
    font-weight: 400;
  }

  .action-button{
    width: 89px;
    height: 31px;
    background: #FAFAFA;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 20px;
    background-color: #20478D;
    font-size: 14px;
    font-weight: 400;
    color: #00DEFF;
  }

  .action-button-base{
    width: 89px;
    height: 31px;
    background: #FAFAFA;
    border: 1px solid rgba(0,144,255,0.84);
    border-radius: 20px;
    background-color: #20478D;
    font-size: 14px;
    font-weight: 400;
    color: #00DEFF;
    display: inline-block;
    line-height: 31px;
    text-align: center;
    text-decoration: none;
  }

  .detail-content{
    display: flex;
    flex-direction: column;
    // margin-right: 20px;

    .equipment-message{
      width: 100%;
      // padding: 5px 0px 0px 6px ;
      border-radius: 18px;

      .stock{
        margin-left:30px;
        width: 60px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(255, 132, 0, 0.84);
        border-radius: 20px;
        // background-color: #B26100;
        // color: #FFCC00;
        background-color: #D3CC15;
        color: black;
        // rgba(255, 132, 0, 0.84);
        font-size: 14px;
        font-weight: 400;

        display: inline-block;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
      }
    }

    .equipment-record{
      margin-top: $main-padding;

      .condition{
          .list-used{
            width: 100%;
            border-radius: 12px 12px 0px 0px;

            .action-button{
              width: 130px;
              height: 40px;

              border: 1px solid rgba(255,132,0,0.84);
              border-radius: 18px;
              font-size: 14px;

              font-weight: 400;
              color: #FFCC00;
              background-color: #8D5620;
            }
          }
      }
    }
  }

  .header-common{
    // width: 100%;
    height: 45px;
    border-radius: 12px 12px 0 0 ;
    background: linear-gradient(-90deg, #001940, #1564BE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .header-common-left{

      font-size: 20px;

      font-weight: bold;
      color: #FEFEFE;
      margin-left: 21px;
      .title{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
      }
    }

    .header-common-right{
      .right-button-export{
        font-size: 14px;
        font-weight: 400;
        color: #00FFB4;
        margin-right: 20px;
      }
    }
  }

  .el-tabs__header{
    background-color: #00FFB4;
  }

}
</style>



// WEBPACK FOOTER //
// src/view/manage/consumables/consumables-hospital-list.vue